/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Profile_Stats_GamesInputs */

const id_profile_stats_games = /** @type {(inputs: Profile_Stats_GamesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} game`)
};

const ms_profile_stats_games = /** @type {(inputs: Profile_Stats_GamesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} permainan`)
};

const da_profile_stats_games = /** @type {(inputs: Profile_Stats_GamesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} spil`)
};

const de_profile_stats_games = /** @type {(inputs: Profile_Stats_GamesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} Spiele`)
};

const en_us2_profile_stats_games = /** @type {(inputs: Profile_Stats_GamesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} games`)
};

const es_es2_profile_stats_games = /** @type {(inputs: Profile_Stats_GamesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} juegos`)
};

const es_mx2_profile_stats_games = /** @type {(inputs: Profile_Stats_GamesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} juegos`)
};

const fil_profile_stats_games = /** @type {(inputs: Profile_Stats_GamesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} laro`)
};

const fr_profile_stats_games = /** @type {(inputs: Profile_Stats_GamesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} jeux`)
};

const it_profile_stats_games = /** @type {(inputs: Profile_Stats_GamesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} giochi`)
};

const hu_profile_stats_games = /** @type {(inputs: Profile_Stats_GamesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} játék`)
};

const nl_profile_stats_games = /** @type {(inputs: Profile_Stats_GamesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} games`)
};

const no_profile_stats_games = /** @type {(inputs: Profile_Stats_GamesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} spill`)
};

const pl_profile_stats_games = /** @type {(inputs: Profile_Stats_GamesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} gier`)
};

const pt_br2_profile_stats_games = /** @type {(inputs: Profile_Stats_GamesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Jogos ${i?.count}`)
};

const pt_profile_stats_games = /** @type {(inputs: Profile_Stats_GamesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} jogos`)
};

const ro_profile_stats_games = /** @type {(inputs: Profile_Stats_GamesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} jocuri`)
};

const fi_profile_stats_games = /** @type {(inputs: Profile_Stats_GamesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} peliä`)
};

const sv_profile_stats_games = /** @type {(inputs: Profile_Stats_GamesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} spel`)
};

const vi_profile_stats_games = /** @type {(inputs: Profile_Stats_GamesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} game`)
};

const tr_profile_stats_games = /** @type {(inputs: Profile_Stats_GamesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} oyun`)
};

const cs_profile_stats_games = /** @type {(inputs: Profile_Stats_GamesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} her`)
};

const bg_profile_stats_games = /** @type {(inputs: Profile_Stats_GamesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} игри`)
};

const ru_profile_stats_games = /** @type {(inputs: Profile_Stats_GamesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} игр`)
};

const uk_profile_stats_games = /** @type {(inputs: Profile_Stats_GamesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} ігор`)
};

const ar_profile_stats_games = /** @type {(inputs: Profile_Stats_GamesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} لعبة`)
};

const hi_profile_stats_games = /** @type {(inputs: Profile_Stats_GamesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} गेम`)
};

const th_profile_stats_games = /** @type {(inputs: Profile_Stats_GamesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} เกม`)
};

const ja_profile_stats_games = /** @type {(inputs: Profile_Stats_GamesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} ゲーム`)
};

const zh_cn2_profile_stats_games = /** @type {(inputs: Profile_Stats_GamesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} 款游戏`)
};

const zh_hant1_profile_stats_games = /** @type {(inputs: Profile_Stats_GamesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} 款遊戲`)
};

const ko_profile_stats_games = /** @type {(inputs: Profile_Stats_GamesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`게임 ${i?.count}개`)
};

/**
* | output |
* | --- |
* | "{count} games" |
*
* @param {Profile_Stats_GamesInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const profile_stats_games = /** @type {((inputs: Profile_Stats_GamesInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Stats_GamesInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_profile_stats_games(inputs)
	if (locale === "ms") return ms_profile_stats_games(inputs)
	if (locale === "da") return da_profile_stats_games(inputs)
	if (locale === "de") return de_profile_stats_games(inputs)
	if (locale === "en-US") return en_us2_profile_stats_games(inputs)
	if (locale === "es-ES") return es_es2_profile_stats_games(inputs)
	if (locale === "es-MX") return es_mx2_profile_stats_games(inputs)
	if (locale === "fil") return fil_profile_stats_games(inputs)
	if (locale === "fr") return fr_profile_stats_games(inputs)
	if (locale === "it") return it_profile_stats_games(inputs)
	if (locale === "hu") return hu_profile_stats_games(inputs)
	if (locale === "nl") return nl_profile_stats_games(inputs)
	if (locale === "no") return no_profile_stats_games(inputs)
	if (locale === "pl") return pl_profile_stats_games(inputs)
	if (locale === "pt-BR") return pt_br2_profile_stats_games(inputs)
	if (locale === "pt") return pt_profile_stats_games(inputs)
	if (locale === "ro") return ro_profile_stats_games(inputs)
	if (locale === "fi") return fi_profile_stats_games(inputs)
	if (locale === "sv") return sv_profile_stats_games(inputs)
	if (locale === "vi") return vi_profile_stats_games(inputs)
	if (locale === "tr") return tr_profile_stats_games(inputs)
	if (locale === "cs") return cs_profile_stats_games(inputs)
	if (locale === "bg") return bg_profile_stats_games(inputs)
	if (locale === "ru") return ru_profile_stats_games(inputs)
	if (locale === "uk") return uk_profile_stats_games(inputs)
	if (locale === "ar") return ar_profile_stats_games(inputs)
	if (locale === "hi") return hi_profile_stats_games(inputs)
	if (locale === "th") return th_profile_stats_games(inputs)
	if (locale === "ja") return ja_profile_stats_games(inputs)
	if (locale === "zh-CN") return zh_cn2_profile_stats_games(inputs)
	if (locale === "zh-Hant") return zh_hant1_profile_stats_games(inputs)
	return ko_profile_stats_games(inputs)
});
export { profile_stats_games as "profile.stats.games" }